import React from "react";

import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../ui/select";

export default function MobileAccountScopeBar({
  selectedTradingAccountId,
  selectedTradingAccount,
  tradingAccounts,
  accountSelectValue,
  onAccountChange,
}) {
  const selectedAccountName = selectedTradingAccount?.account_name || "No account connected";
  const accountUnavailable = (
    selectedTradingAccount?.is_active === false
    || selectedTradingAccount?.can_trade === false
  );

  return (
    <div
      data-testid="mobile-account-scope-bar"
      data-account-id={selectedTradingAccountId || "none"}
      className="relative z-40 shrink-0 border-b border-white/10 bg-[#0b0f17]/95 px-3 py-2 shadow-[0_8px_24px_rgba(0,0,0,0.28)] backdrop-blur lg:hidden"
    >
      <div className="flex min-w-0 items-center gap-3">
        <div className="shrink-0">
          <div className="text-[9px] font-semibold uppercase tracking-[0.18em] text-white/45">
            Active account
          </div>
          <div className="mt-1 flex items-center gap-1.5 text-[10px] text-white/55">
            <span
              className={`h-1.5 w-1.5 rounded-full ${
                !selectedTradingAccountId
                  ? "bg-white/30"
                  : accountUnavailable
                    ? "bg-amber-400"
                    : "bg-emerald-400"
              }`}
              aria-hidden="true"
            />
            <span>{accountUnavailable ? "Unavailable" : selectedTradingAccountId ? "Selected" : "None"}</span>
          </div>
        </div>

        <Select
          value={accountSelectValue}
          onValueChange={onAccountChange}
          disabled={!tradingAccounts.length}
        >
          <SelectTrigger
            aria-label="Selected trading account"
            title={selectedAccountName}
            className="h-10 min-w-0 flex-1 border-white/15 bg-white/[0.06] text-left text-xs text-white [&>span]:truncate"
          >
            <SelectValue placeholder="Select account" />
          </SelectTrigger>
          <SelectContent className="bg-black border-white/10">
            {!tradingAccounts.length ? (
              <SelectItem value="none" className="text-white focus:bg-white/10">
                No account connected
              </SelectItem>
            ) : (
              tradingAccounts.map((entry) => (
                <SelectItem key={entry.id} value={entry.id} className="text-white focus:bg-white/10">
                  {entry.account_name}
                </SelectItem>
              ))
            )}
          </SelectContent>
        </Select>
      </div>
    </div>
  );
}
